module.exports = __webpack_public_path__ + "img/Strip-Front-B5-Jd.826562c1.png";